import { type InventoryCategory } from '@/types/InventoryCategory';
import { useQuery } from '@tanstack/vue-query';
import { tenantReady } from './tenantReady';

export function useMoveInventoryCategories() {
    const {
        data: inventoryCategories,
        isLoading,
        isFetching,
        isFetched,
        refetch,
        error,
    } = useQuery({
        queryKey: ['inventory-categories'],
        queryFn: getInventoryCategories,
        enabled: tenantReady,
        retry: false,
        staleTime: 1000 * 60 * 60 * 24, // 24 hours
    });

    async function getInventoryCategories() {
        // Explicit limit: only page 1 is read, so without it any category past the
        // server's default page size would silently vanish from the room list.
        const response = await window.axios.get('/customers/book/inventory-categories?type=MOVE&limit=500');
        return response.data.data as InventoryCategory[];
    }

    function getInventoryCategory(inventoryCategoryId: number) {
        return inventoryCategories.value?.find((category) => category.id === inventoryCategoryId);
    }

    return {
        inventoryCategories,
        isLoading,
        isFetching,
        isFetched,
        refetch,
        error,
        getInventoryCategory,
    };
}
